/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

/**
 * A developer field declaration, assembled from the `developer_data_id` message
 * that claimed an index and the `field_description` message that described one
 * of its fields.
 *
 * Emitted by the decoder as the declarations are met, so a caller can register
 * them with an encoder to re-emit the same extension fields.
 */
public class DeveloperFieldDescription(
    applicationId: ByteArray?,
    public val applicationVersion: UInt?,
    public val developerDataIndex: UByte,
    public val fieldDefinitionNumber: UByte,
    public val fieldName: String,
    public val baseType: BaseType,
    public val units: String = "",
    public val scale: Double = Fit.FIELD_DEFAULT_SCALE,
    public val offset: Double = Fit.FIELD_DEFAULT_OFFSET,
    public val nativeFieldNum: UByte? = null,
) {
    // Copied in and copied out, like DeveloperField's: a declaration whose
    // application UUID a caller can rewrite is a declaration that can be made to
    // describe someone else's field.
    private val applicationIdBytes: ByteArray? = applicationId?.copyOf()

    /** Application UUID of the `developer_data_id` that claimed the index. */
    public val applicationId: ByteArray? get() = applicationIdBytes?.copyOf()

    public val key: DeveloperDataKey
        get() = DeveloperDataKey(applicationIdBytes?.toList(), developerDataIndex, fieldDefinitionNumber)

    /** A fresh, empty field this description describes. */
    public fun createField(): DeveloperField =
        DeveloperField(
            fieldName = fieldName,
            fieldNum = fieldDefinitionNumber,
            baseType = baseType,
            developerDataIndex = developerDataIndex,
            units = units,
            scale = scale,
            offset = offset,
            nativeFieldNum = nativeFieldNum,
            applicationId = applicationId,
        )

    override fun toString(): String = "DeveloperFieldDescription($fieldName, dev #$developerDataIndex/$fieldDefinitionNumber)"
}
